import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from 'src/app/_base/base.component';
import { CommunicationsPostTypes } from 'src/app/_enums';
import { EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji/public_api';
import { SocialLearningService, UserService } from 'src/app/_services';
import { FileUpload, SocialLearningPost, PostGetResult, SocialLearningPostGet, PagedResult, StudentsLookups } from 'src/app/_models';
import { FileStatuses } from 'src/app/_enums/file-statuses.enum';
import { UserBasicInformation } from 'src/app/_models/users/user-basic-information';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-communications-post',
  templateUrl: './communications-post.component.html',
  styleUrls: ['./communications-post.component.scss']
})
export class CommunicationsPostComponent extends BaseComponent implements OnInit {
  @Input()
  sectionSubjectId: number = null;
  @Input()
  postType: number = CommunicationsPostTypes.private;
  files: FileUpload[] = [];
  students: StudentsLookups[] = [];
  selectedStudents: string[] = [];
  postComment: string = null;
  inAddMode: boolean = false;
  isOpenedEmoji: boolean = false;
  sharingMode: number = 0;
  isUploaderOpened: boolean = false;
  communicationsPostTypes = CommunicationsPostTypes;
  search: string = null;
  isLoading: boolean = false;
  posts: SocialLearningPostGet = {
    results: [],
    totalRecords: 0
  };
  constructor(private userService: UserService, private socialLearningService: SocialLearningService) {
    super();
  }

  ngOnInit() {}
  getStudents(): void {
    this.isLoading = true;
    this.userService.getStudentsBySectionSubjectId(this.sectionSubjectId).subscribe(
      (data: UserBasicInformation[]) => {
        data.map(item =>
          this.students.push({
            studentId: item.id,
            studentName: item.fullName,
            studentNameEn: item.fullNameEn
          })
        );
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
      }
    );
  }
  openAddMode(): void {
    this.inAddMode = true;
  }
  openAddAndUploader(): void {
    if (!this.inAddMode) this.inAddMode = true;
    this.isUploaderOpened = !this.isUploaderOpened;
  }
  closeAddMode(): void {
    this.inAddMode = false;
  }
  closeOnClickOutside() {
    this.inAddMode = false;
  }
  openEmoji(): void {
    this.isOpenedEmoji = !this.isOpenedEmoji;
  }
  emojiSelection(emojiEvent: EmojiEvent): void {
    if (emojiEvent.emoji.unified !== '1F595-1F3FB') {
      if (this.postComment) this.postComment += ' ' + emojiEvent.emoji.native;
      else this.postComment = emojiEvent.emoji.native;
      this.isOpenedEmoji = false;
    }
  }
  sharingModeChanged(): void {
    if (this.sharingMode === 0) {
      this.selectedStudents = [];
      this.students = [];
    } else {
      this.getStudents();
    }
  }
  updateChecked(studentId: string, isChecked: boolean): void {
    if (isChecked) {
      this.selectedStudents.push(studentId);
    } else {
      const selectedStudentIndex: number = this.selectedStudents.findIndex(item => item === studentId);
      if (selectedStudentIndex !== -1) this.selectedStudents.splice(selectedStudentIndex, 1);
    }
  }
  resetAndCloseAdd(): void {
    this.files = [];
    this.postComment = null;
    this.inAddMode = false;
    this.sharingMode = 0;
    this.selectedStudents = [];
  }
  commentPost(): void {
    if (this.files.findIndex(item => item.status === FileStatuses.uploading) !== -1) {
      this.showWarning('Common.UploadingFileInProgress');
      return;
    }
    if (this.files.findIndex(item => item.status === FileStatuses.failed) !== -1) {
      this.showError('Common.ThereIsAFileThatFailsToUpload');
      return;
    }
    if (this.files.findIndex(item => item.status === FileStatuses.failed) !== -1) {
      this.showWarning('Common.UploadingFileInProgress');
      return;
    }
    if (!this.postComment.match(/\S/gm)) {
      this.showError('Common.PostMustIncludeAtLeastOneCharacter');
      return;
    }
    const attachmentIds: number[] = [];
    this.files.map(item => attachmentIds.push(item.result.attachmentId));
    const socialLearningPost: SocialLearningPost = {
      postItemText: this.postComment,
      postTypeId: this.postType,
      sectionSubjectId: this.sectionSubjectId,
      attachmentIds: attachmentIds
    };
    if (this.sharingMode === 1) {
      socialLearningPost.studentIds = [];
      this.selectedStudents.map(item => {
        socialLearningPost.studentIds.push(item);
      });
    }
    this.isLoading = true;
    this.socialLearningService.CreatePost(socialLearningPost).subscribe(
      (data: PostGetResult) => {
        data.postFiles = [];
        data.postImages = [];
        data.postAttachments.map(subItem => {
          if (subItem.attachmentMimeType && subItem.attachmentMimeType.includes('image')) data.postImages.push(subItem);
          else data.postFiles.push(subItem);
        });
        this.posts.results.splice(0, 0, data);
        this.posts.totalRecords += 1;
        this.showSuccess('Common.PostCreatedSuccessfully');
        this.resetAndCloseAdd();
        this.isLoading = false;
      },
      () => {
        this.showError('Common.ErrorWhileCreatingPost');
        this.isLoading = false;
      }
    );
  }
}
